// extracted by mini-css-extract-plugin
export default {"item":"styles_item__BWlmR","left":"styles_left__Q8NgF","right":"styles_right__Em1NK"};